import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Bu bileşen sayfa değişikliklerinde otomatik olarak sayfayı en üste kaydırır
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // Yumuşak geçiş için
    });
  }, [pathname]); // URL değiştiğinde çalışır

  return null; // Görünür hiçbir şey render etmez
};

export default ScrollToTop;
